<div mat-dialog-title class="flex flex-row justify-between items-center">
  <span>Reset temporary password</span>
  <button [mat-dialog-close]="false" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <span class="detail-label"
    >Your temporary password has expired. Click on "Reset Temporary Password" to receive a new temporary password by
    email. If you encounter any further issues, kindly contact Customer Support for assistance.</span
  >
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row justify-end">
  <button mat-raised-button type="submit" color="primary" style="margin-right: 10px" (click)="onResetTempPassword()">
    Reset temporary password
  </button>
</mat-dialog-actions>
